import React, { useEffect } from 'react';
import Header from '../component/layout/Header';
import Footer from '../component/layout/Footer';
import Delivery from "../component/User/Delivery/Delivery.jsx";

const DeliveryPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="flex-grow">
        <Delivery /> {/* Delivery starts from top */}
      </div>
      <Footer />
    </div>
  );
};

export default DeliveryPage;
